<template>
  <div class="wego-kiosk-shell">
    <RouterView />
  </div>
</template>

<style lang="scss">
#app {
  width: 100%;
  min-height: 100vh;
}

.wego-kiosk-shell {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  padding: clamp(20px, 3.5vw, 60px) clamp(20px, 5vw, 80px);
  transition: padding 240ms ease;
}

@media (max-width: 959px) {
  // .wego-kiosk-shell {
  //   padding: 16px;
  // }
}

/* Portrait kiosk: wider padding on tall narrow screens */
@media (orientation: portrait) and (min-width: 960px) {
  // .wego-kiosk-shell {
  //   padding: clamp(30px, 4vw, 80px) clamp(30px, 6vw, 120px);
  // }
}
</style>
